export {
  IfcExpression,
  IfcExpressionParseResult,
  IfcElementAccessor,
  IfcExpressionContext,
  Value,
  StringValue,
  BooleanValue,
  LogicalValue,
  NumericValue,
  ExpressionValue,
  ReferenceValue,
  IfcDateValue,
  IfcDateTimeValue,
  IfcTimeValue,
  IfcDurationValue,
  IfcTimeStampValue,
  IfcPropertySetAccessor,
  IfcPropertyAccessor,
  IfcRootObjectAccessor,
  IfcTypeObjectAccessor,
  NamedObjectAccessor,
  ObjectAccessor,
  Expr,
  ExprCompiler,
  ExprKind,
  IfcExpressionEvaluationException,
  IfcExpressionErrorListener,
  IfcExpressionVisitor,
  isPresent,
  isNullish,
  ExprEvalResult,
  ExprEvalError,
  isExprEvalError,
  isExprEvalSuccess,
  ExprToTextInputLinker,
  ExprFacade,
  ExprType,
  ArrayType,
  SimpleType,
  TupleType,
  TypeDisjunction,
  Types,
} from "./IfcExpression.js";

export type { BoxedValueTypes } from "./IfcExpression.js";

export { E } from "./E.js";
